// extracted by mini-css-extract-plugin
module.exports = {"cleanBtn":"ManufacturersAdvancedFilters_cleanBtn__bTqk1"};